export default __webpack_public_path__ + "static/media/Img_ResourceBank_Top.8960932c.png";